import React from 'react';
import PropTypes from 'prop-types';

import { StyledChannelLogosWrapper, StyledIcon } from './style';

const ChannelLogos = ({ logos }) => (
  <StyledChannelLogosWrapper>
    {logos.map(logo => (
      <StyledIcon
        key={logo.id}
        svg={logo}
        width="30px"
        height="26px"
        color="grayDark"
      />
    ))}
  </StyledChannelLogosWrapper>
);

ChannelLogos.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      id: PropTypes.string,
      node: PropTypes.any,
      viewBox: PropTypes.string
    })
  )
};

export default ChannelLogos;
